import { ModalOverlay, StyleCardLarge, StyleImageLarge, StyleNameLarge, StylesApplyButton, StylesGridInner, StylesGridLarge, StylesModalContainer, StylesModalHeader, StylesModalTitle } from './CreateAIDesign.styles'

export const AllStylesModal = ({ isOpen, onClose, designStyles, selectedStyleInModal, setSelectedStyleInModal, onApply }) => {
  if (!isOpen) return null

  const handleApply = () => {
    onApply()
  }

  return (
    <ModalOverlay onClick={onClose}>
      <StylesModalContainer onClick={e => e.stopPropagation()}>
        {/* <ModalCloseButton onClick={onClose}>
          <img src={closeIcon} alt="Close" />
        </ModalCloseButton> */}
        <StylesModalHeader>
          <StylesModalTitle>All Styles</StylesModalTitle>
          <StylesApplyButton onClick={handleApply} disabled={!selectedStyleInModal}>
            Apply
          </StylesApplyButton>
        </StylesModalHeader>
        <StylesGridLarge>
          <StylesGridInner>
            {designStyles
              .filter(style => !style.isCustom)
              .map(style => (
                <StyleCardLarge key={style.id} selected={selectedStyleInModal === style.id} onClick={() => setSelectedStyleInModal(style.id)}>
                  <StyleImageLarge src={style.image} alt={style.name} />
                  <StyleNameLarge selected={selectedStyleInModal === style.id}>{style.name}</StyleNameLarge>
                </StyleCardLarge>
              ))}
          </StylesGridInner>
        </StylesGridLarge>
      </StylesModalContainer>
    </ModalOverlay>
  )
}
